module.exports = __webpack_public_path__ + "static/media/green_check.02bc01ea.png";